export default {
  days: ['ئاهد', 'اثنين', 'ثلاثاء', 'اربعاء', 'خميس', 'جمعة', 'سبت'],
  months: ['جانواري', 'فبرواري', 'مارچ', 'اڤريل', 'مي', 'جون',
           'جولاي', 'ائوڬوس', 'سيڤتيمبر', 'ائوکتوبر', 'نوۏيمبر', 'ديسيمبر'],

  common: {
    save:          'سيمڤن',
    close:         'توتوڤ',
    cancel:        'باتل',
    back:          'کمبالي',
    add:           'تمبه',
    noData:        'تيادا داتا',
    male:          'لاکي-لاکي',
    female:        'ڤرمڤوان',
    error:         'رالت برلاکو',
    studyYear:     (y) => `تاهون ڤلاجارن ${y}`,
    studyYearShort:(y) => `تاهون ${y}`,
    classNo:       (c, r) => `دارجه ${c} بيليک ${r}`,
    studentCount:  (n) => `مريد ${n} ئورڠ`,
    personCount:   (n) => `${n} ئورڠ`,
    active:        'أکتيف',
    withdrawn:     'جوال',
    years:         'تاهون',
  },

  subjectList: {
    pageTitle:        'ماتا ڤلاجرن سايا (باهاڬيان اڬام)',
    noTeaching:       'تيادا ماکلومت ڤڠاجارن',
    colCode:          'کود سمستر ١',
    colCode2:         'کود سمستر ٢',
    colName:          'نام ماتا ڤلاجرن',
    colSchedule:      'جدول حصة',
    colAttend:        'ڤريکسا ناما',
    colScore:         'مرک',
    studentListBtn:   'سناراي مريد',
    attendBtn:        'ڤريکسا ناما',
    scoreBtn:         'مرک',
    noStudents:       'تيادا سناراي مريد',
    studentInfo:      'ماکلومت مريد',
    identity:         'ڤريبادي',
    address:          'الامت',
    father:           'بايه',
    mother:           'إيبو',
    guardian:         'والي',
    dormitory:        'اسرامه',
    studentId:        'نومبور مريد',
    idCard:           'کاد ڤڠنالن',
    gender:           'جنتينا',
    status:           'ستاتوس',
    birthDate:        'تاريخ لاهير',
    age:              'اومور',
    fatherName:       'نام بايه',
    fatherPhone:      'نومبور تليفون بايه',
    motherName:       'نام إيبو',
    motherPhone:      'نومبور تليفون إيبو',
    guardianName:     'نام والي',
    guardianRelation: 'هوبوڠن',
    guardianPhone:    'نومبور تليفون والي',
    dormName:         'اسرامه',
    village:          'کامڤوڠ',
    checkinDate:      'تاريخ ماسوق',
    noDorm:           'تيادا مقيم دي اسرامه',
  },

  attendance: {
    pageTitle:    'ڤريکسا ناما ڤلاجارن',
    noSchedule:   'تيادا جدوال ڤڠاجارن اونتوق هاري اين',
    colPeriod:    'حصة',
    colTime:      'ماس',
    colSubject:   'ماتا ڤلاجرن',
    colClass:     'كلس',
    colGender:    'جنتينا',
    checkBtn:     'ڤريکسا ناما',
  },

  checkAttendance: {
    pageTitle:          'ڤريکسا ناما — بيليک',
    breadcrumb:         'ڤريکسا ناما',
    alreadyChecked:     'سودا ڤريکسا ناما اونتوق حصة اين',
    editLink:           'کليک اونتوق سوڠيت',
    labelDate:          'تاريخ:',
    labelTopic:         'توڤيک:',
    topicPlaceholder:   'اسي توڤيک ڤلاجارن هاري اين',
    saveBtn:            'سيمڤن ڤريکسا ناما',
    saveSuccess:        'جاي ديسيمڤن',
    noStudents:         'تيادا سناراي مريد',
    colId:              'نومبور',
    colName:            'نام-ڤڠکت',
    colStatus:          'ستاتوس',
    statusPresent:      'حاضر',
    statusLate:         'لمبت',
    statusLeave:        'چوتي',
    statusAbsent:       'ڬاڬل حاضر',
    statusWithdrawn:    'جوال',
    statusTransferred:  'ڤيندهه کلس',
    transferredTo:      (room) => `(ڤيندهه ک ${room})`,
    skippedHint:        (n) => `${n} اورڠ دلڠکاو (کلوار/ڤيندهه کلس) — تيدق دريکودکن`,
    noCheckable:        'تياد مريد يڠ ڤرلو دأمبيل کحاضيرن دالم کلس اين',
    leaveHome:          'بالق کرومه',
    leaveByAdvisor:     'ݢورو کلس عام ممبريتاهو چوتي',
    leaveByDiscipline:  'باهاݢين تاتاترتيب ممبريتاهو چوتي',
    leaveByAcademic:    'کتوا اکاديميک ممبريتاهو چوتي',
    leaveByIslamicAdvisor: 'ݢورو کلس اڬام ممبريتاهو چوتي',
    leaveReturned:      'سوده کمبالي کسکوله',
    errorTitle:         'رالت',
    viewCard:           'کاد',
    viewTable:          'جادول',
  },

  editAttendance: {
    pageTitle:        'سوڠيت ڤريکسا ناما — بيليک',
    breadcrumb:       'ڤريکسا ناما',
    breadcrumbEdit:   (r) => `سوڠيت — بيليک ${r}`,
    labelDate:        'تاريخ:',
    labelTopic:       'توڤيک:',
    topicPlaceholder: 'اسي توڤيک ڤلاجارن',
    saveSuccess:      'جاي ديکمسکيني',
    noData:           'تيادا داتا',
    colId:            'نومبور',
    colName:          'نام-ڤڠکت',
    colStatus:        'ستاتوس',
    saveBtn:          'سيمڤن',
    backBtn:          'کمبالي',
    errorTitle:       'رالت',
  },

  scoreEntry: {
    pageTitle:    'سيمڤن مرک (باهاڬيان اڬام)',
    unsaved:      'اد ڤروبهن يڠ بلوم دسيمڤن',
    studentCount: (n) => `سناراي مريد (${n} ئورڠ)`,
    average:      'ڤوراتا',
    semester1:    'سيميستر 1',
    semester2:    'سيميستر 2',
    total:        'سموا',
    saveBtn:      'سيمڤن مرک',
    saveSuccess:  'جاي ديسيمڤن',
    saveError:    'رالت برلاکو',
    noStudents:   'تيادا سناراي مريد',
    colId:        'نومبور',
    colArabicName:'نام عربي',
    colName:      'نام-ڤڠکت',
  },

  attendanceStat: {
    pageTitle:         'ستاتيستيک ڤريکسا ناما (باهاڬيان اڬام)',
    selectSubject:     'ماتا ڤلاجرن يڠ دأجر',
    subjectPlaceholder:'-- ڤيليه ماتا ڤلاجرن --',
    pickHint:          'ڤيليه ماتا ڤلاجرن اونتوق مليهت ستاتيستيک ڤريکسا ناما',
    noSessions:        'بلوم اد ڤريکسا ناما دالم ماتا ڤلاجرن اين',
    statBtn:           'ستاتيستيک',
    colStat:           'ستاتيستيک',
    sessions:          'کالي ڤريکسا ناما',
    students:          'مريد',
    avgRate:           'کادر کحاضيرن',
    rateHint:          'حاضير + لمبت ÷ کالي يڠ دڤريکسا',
    colNo:             'بيل',
    colId:             'نومبور',
    colName:           'نام-ڤڠکت',
    colRate:           'ڤراتوس',
    periodShort:       (n) => `حصة ${n}`,
    notChecked:        'تيادا ماکلومت ڤريکسا ناما',
    printBtn:          'چيتق',
    excelBtn:          'Export Excel',
    short: { present: 'ح', late: 'ل', leave: 'چ', absent: 'ت' },
  },

  manageTeaching: {
    pageTitle:               'جدول ڤڠاجارن (ڬلوله)',
    classRoom:               'بيليک دارجه',
    filterClass:             'دارجه',
    filterGender:            'جنتينا',
    noRooms:                 'تيادا بيليک دارجه',
    selectRoom:              'ڤيليه بيليک دارجه اونتوک مليهت جدول ڤڠاجارن',
    addTeachingBtn:          'تمبه ڤڠاجارن',
    noTeachings:             'بلوم اد ڤنوڬاسن ڤڠاجارن دالم بيليک اين',
    colCode:                 'کود',
    colSubjectName:          'نام ماتا ڤلاجرن',
    colTeacher:              'ڬورو ڤڠاجار',
    colDayPeriod:            'هاري / حصة',
    assignPeriodTitle:       'تتڤکن حصة',
    addTeachingModalTitle:   'تمبه ڤڠاجارن',
    labelSubject:            'ماتا ڤلاجرن',
    subjectPlaceholder:      '-- ڤيليه ماتا ڤلاجرن --',
    allSubjectsAssigned:     'ماتا ڤلاجرن سموا سوده دتوڬاسکن',
    labelTeacher:            'ڬورو ڤڠاجار',
    teacherPlaceholder:      '-- ڤيليه ڬورو --',
    labelDay:                'هاري',
    dayPlaceholder:          '-- ڤيليه هاري --',
    labelPeriod:             'حصة',
    periodPlaceholder:       '-- ڤيليه حصة --',
    noPeriods:               'بلوم اد حصة دتتڤکن',
    duplicatePeriod:         'حصة اين سوده دتمبه',
    confirmDeleteTitle:      'يکينکن ڤادم؟',
    confirmDeleteBtn:        'ڤادم',
    cancelDeleteBtn:         'باتل',
    deleteFailMsg:           'تيداق دڤات دڤادم',
    errorShort:              'رالت',
  },

  timetableEditor: {
    pageTitle:          'ڬلوله جدول ڤڠاجارن',
    roomPlaceholder:    '-- ڤيليه بيليک دارجه --',
    subjectsTitle:      'ماتا ڤلاجرن دالم کوريکولوم',
    dragHint:           '(هيريت دان لتق کدالم جدول)',
    noSubjects:         'تيادا ماتا ڤلاجرن دالم کوريکولوم بيليک اين',
    noPeriods:          'بلوم اد حصة دتتڤکن اونتوق تاهون ڤلاجارن اين',
    colDay:             'هاري',
    periodNo:           (n) => `حصة ${n}`,
    exportPdf:          'موات تورون PDF',
    print:              'چيتق',
    empty:              'کوسوڠ',
    docTitle:           (room) => `جدول ڤڠاجارن اڬام — دارجه ${room}`,
    docFile:            (room) => `جدول-ڤڠاجارن-اڬام_${room}`,
    cannotDrop:         'تيداق بوليه دلتق',
    cellOccupied:       'روانݢ اين سوده اد ماتا ڤلاجرن',
    confirmDeleteSlot:  'ڤادم حصة اين درڤد جدول؟',
    deleteSlotTitle:    'ڤادم درڤد جدول',
    teacherModalTitle:  'ڤيليه ڬورو ڤڠاجار',
    labelSlot:          'هاري / حصة',
    conflictTitle:      'ڬورو اد ماس برتيندايه',
    conflictBody:       (room) => `ڬورو سوده مڠاجر بيليک <strong>${room}</strong> ڤد حصة اين`,
    conflictAsk:        (action) => `تروسکن ${action}؟`,
    actionAdd:          'تمبه',
    actionMove:         'ڤينده',
    addFail:            'تيداق دڤات منمبه حصة',
    moveFail:           'تيداق دڤات ممينداهکن حصة',
    assignFail:         'تيداق دڤات منمبه ماتا ڤلاجرن کدالم جدول',
  },

  teachingTracking: {
    pageTitle:          'ڤنتاوان ڤڠاجارن',
    classRoom:          'بيليک دارجه',
    noRooms:            'تيادا بيليک دارجه',
    selectRoom:         'ڤيليه بيليک دارجه اونتوک ليهت ستاتوس ڤڠاجارن',
    noTeachings:        'بلوم اد ڤنوڬاسن ڤڠاجارن دالم بيليک اين',
    colCode:            'کود',
    colSubjectName:     'نام ماتا ڤلاجرن',
    colTeacher:         'ڬورو ڤڠاجار',
    colAttSessions:     'کالي ڤريکسا ناما',
    colStudentsScore:   'مريد ميليکي مرک',
    times:              'کالي',
    attendBtn:          'ناما',
    scoreBtn:           'مرک',
    viewLogBtn:         'چاتتن ڤڠاجارن',
  },

  listTeachTracking: {
    pageTitle:    'چاتتن ڤڠاجارن',
    breadHome:    'لامن اوتام',
    breadCurrent: 'چاتتن ڤڠاجارن',
    listTitle:    'سناراي چاتتن',
    countTimes:   (n) => `${n} کالي`,
    noRecords:    'بلوم اد چاتتن ڤڠاجارن',
    colDate:      'تاريخ',
    colTime:      'ماس',
    colPeriod:    'حصة',
    colTopic:     'توڤيک ڤڠاجارن',
    colPresent:   'حاضر',
    colAbsent:    'ڬاڬل',
    colLate:      'لمبت',
    colLeave:     'چوتي',
    colTotal:     'جوملاه',
    noTopic:      'تيادا توڤيک',
  },

  classGrade: {
    pageTitle:     'جدول مرک باهاڬيان اڬام',
    classRoom:     'بيليک دارجه',
    noRooms:       'تيادا بيليک دارجه',
    selectRoom:    'ڤيليه بيليک دارجه اونتوق ليهت مرک',
    tabScores:     'مرک',
    tabAttendance: 'ڤرهاديران',
    noSubjects:    'بلوم اد ماتا ڤلاجرن دلم بيليک اين',
    noAttendance:  'بلوم اد داتا ڤرهاديران',
    colNo:         'نومبور',
    colName:       'نام-ڤڠکت',
    colAverage:    'ڤوراتا',
    colPresent:    'حاضر',
    colAbsent:     'ڬاڬل',
    colLate:       'لمبت',
    colLeave:      'چوتي',
    colTotal:      'جوملاه',
    genderLabel:   (g) => g === 'male' ? 'لاکي-لاکي' : g === 'female' ? 'ڤرمڤوان' : 'جوملاه',
  },

  advisorHome: {
    pageTitle:         'بيليک دارجه سايا (باهاڬيان اڬام)',
    noRoom:            'تيادا بيليک دارجه دالم تاهون ڤلاجارن اين',
    labelStudents:     'مريد',
    labelSubjects:     'ماتا ڤلاجرن',
    cardStudentsTitle: 'سنارائي مريد',
    cardStudentsDesc:  'ليهت سموا مريد دالم بيليک دارجه',
    cardStudentsBtn:   'ليهت مريد',
    cardGradesTitle:   'مرک & ڤرهاديران',
    cardGradesDesc:    'ليهت مرک دان ڤرهاديران مريد',
    cardGradesBtn:     'ليهت مرک',
    cardDormTitle:     'ڬلوله اسراما',
    cardDormDesc:      'اتور مريد ماسوق اسراما دان ڤيندهکن بلوق',
    cardDormBtn:       'ڬلوله اسراما',
    cardLeaveTitle:    'ممبريتاهو چوتي مريد',
    cardLeaveDesc:     'ممبريتاهو سکالي، برکسن اونتوق باهاڬين اڬام دان عام',
    cardLeaveBtn:      'ممبريتاهو چوتي',
    cardTimetableTitle:'جدول ڤڠاجارن',
    cardTimetableDesc: 'ليهت جدول ڤڠاجارن بيليک دارجه سڤنجڠ مڠڬو',
    cardTimetableBtn:  'ليهت جدول',
  },

  teacherTimetable: {
    pageTitle:    'جدول ڤڠاجارن ستياڤ ڬورو',
    myPageTitle:  'جدول ڤڠاجارن سايا',
    pickTeacher:  'ڤيليه ڬورو اونتوق مليهت جدول ڤڠاجارن',
    colDay:       'هاري',
    periodNo:     (n) => `حصة ${n}`,
    empty:        'کوسوڠ',
    noPeriods:    'بلوم اد حصة دتتڤکن اونتوق تاهون ڤلاجارن اين',
    noTimetable:  (name) => `${name} بلوم اد جدول ڤڠاجارن دالم تاهون ڤلاجارن اين`,
    docTitle:     (name) => `جدول ڤڠاجارن اڬام — ${name}`,
    docFile:      (name) => `جدول-ڤڠاجارن-اڬام_${name}`,
    docRoom:      (room) => `دارجه ${room}`,
    noMyTimetable:'اندا بلوم اد جدول ڤڠاجارن دالم تاهون ڤلاجارن اين',
    slotSummary:  (n) => `جوملة ${n} حصة/مڠڬو`,
    conflictBadge:'اد حصة برتيندايه',
    conflictHint: 'روانݢ ميره = ڬورو دتوڬاسکن د بيليک لائين ڤد حصة يڠ سام',
    exportPdf:    'موات تورون PDF',
    print:        'چيتق',
  },

  advisorTimetable: {
    pageTitle:  'جدول ڤڠاجارن بيليک دارجه',
    colDay:     'هاري',
    periodNo:   (n) => `حصة ${n}`,
    empty:      'کوسوڠ',
    noPeriods:  'بلوم اد حصة دتتڤکن اونتوق تاهون ڤلاجارن اين',
    docTitle:   (room) => `جدول ڤڠاجارن اڬام — دارجه ${room}`,
    docFile:    (room) => `جدول-ڤڠاجارن-اڬام_${room}`,
    exportPdf:  'موات تورون PDF',
    print:      'چيتق',
  },

  advisorLeave: {
    pageTitle:      'ممبريتاهو چوتي مريد',
    breadcrumb:     'ݢورو کلس (باهاڬين اڬام)',
    noRoom:         'تيادا بيليک دارجه دالم تاهون ڤلاجارن اين',
    linkedNote:     'ممبريتاهو چوتي دسيني سکالي سهاج، برکسن اونتوق ڤرهاديران باهاڬين اڬام دان باهاڬين عام — ݢورو کلس عام تيدق ڤرلو ممبريتاهو لاڬي، دان هاڽ برکسن اونتوق ڤرهاديران يڠ برايکوتڽ',
    formTitle:      'تمبه چوتي',
    labelDays:      'بيلاڠن هاري چوتي',
    daysCustom:     'تنتوکن سنديري',
    daysUnit:       (n) => `${n} هاري`,
    daysHelp:       'ڤيليه بيلاڠن هاري، سيستم اکن تنتوکن تاريخ تامت سچارا اوتوماتيک',
    labelStart:     'تاريخ مولا',
    labelEnd:       'تاريخ تامت',
    labelType:      'جنيس چوتي',
    typeSick:       'چوتي ساکيت',
    typePersonal:   'چوتي عروسن',
    labelNote:      'چاتتن',
    notePlaceholder:'سبب چوتي (جک اد)',
    labelStudents:  (n) => `ڤيليه مريد (${n})`,
    selectAll:      'ڤيليه سموا',
    clearAll:       'باتل سموا',
    noStudents:     'تيادا مريد',
    save:           'سيمڤن چوتي',
    saving:         'سدڠ مڽيمڤن...',
    listTitle:      'سنارائي چوتي',
    colName:        'نام-ڤڠکت',
    colRoom:        'بيليک عام',
    colRange:       'تمڤوه چوتي',
    colType:        'جنيس',
    colSource:      'ڤمبريتاهو',
    colNote:        'چاتتن',
    rangeTo:        'هيڠڬ',
    noLeaves:       'بلوم اد چوتي',
    homeLeave:      'سورت بالق کرومه',
    noRegularStudy: 'تيادا ڤندفترن عام تاهون اين',
    noRegularHelp:  'مريد يڠ تيادا ڤندفترن باهاڬين عام تاهون اين تيدق بوليه دبريتاهو چوتي دسيني، کران چوتي دايکت دڠن ڤندفترن عام سوڤاي برکسن اونتوق کدوا-دوا باهاڬين',
    overlapWarn:    (n) => `${n} مريد يڠ دڤيليه سوده اد چوتي دالم تمڤوه اين — سيستم اکن ملڠکاويڽ، تيدق دسيمڤن دوا کالي`,
    savedSomeTitle: (n) => `چوتي ${n} اورڠ مريد دسيمڤن`,
    savedSomeText:  (n) => `${n} اورڠ دلڠکاوي کران سوده اد چوتي دالم تمڤوه اين`,
    savedNoneTitle: 'تيادا يڠ دتمبه',
    savedNoneText:  (n) => `کسموا ${n} اورڠ مريد يڠ دڤيليه سوده اد چوتي دالم تمڤوه اين`,
    deleteTitle:    'صحکن ڤمادمن',
    deleteText:     (name) => `ڤادم چوتي ${name}؟`,
    deleteConfirm:  'ڤادم',
    cancel:         'باتل',
    onlyOwnDelete:  'هاڽ بوليه ممادم چوتي يڠ دبريتاهو دري باهاڬين اڬام',
    savedTitle:     'چوتي برجاي دسيمڤن',
    deletedTitle:   'برجاي دڤادم',
    errorTitle:     'رالت',
    warnNoStudent:  'سيلا ڤيليه سکورڠ٢ڽ ١ اورڠ مريد',
    warnNoStudentTitle: 'بلوم ممیليه مريد',
    warnRangeTitle: 'تمڤوه تاريخ تيدق صح',
    warnRange:      'تاريخ مولا تيدق بوليه ملبيهي تاريخ تامت',
  },

  advisorGrade: {
    pageTitle:     'مرک & ڤرهاديران',
    noRoom:        'تيادا بيليک دارجه دالم تاهون ڤلاجارن اين',
    tabScores:     'مرک',
    tabAttendance: 'ڤرهاديران',
    noSubjects:    'بلوم اد ماتا ڤلاجرن دالم بيليک اين',
    noAttendance:  'بلوم اد داتا ڤرهاديران',
    colNo:         'نومبور',
    colName:       'نام-ڤڠکت',
    colAverage:    'ڤوراتا',
    colPresent:    'حاضر',
    colAbsent:     'ڬاڬل',
    colLate:       'لمبت',
    colLeave:      'چوتي',
    colTotal:      'جوملاه',
  },

  advisorStudents: {
    pageTitle:     'سنارائي مريد',
    noRoom:        'تيادا بيليک دارجه دالم تاهون ڤلاجارن اين',
    totalStudents: 'جوملاه مريد',
    noStudents:    'بلوم اد مريد دالم بيليک اين',
    colNo:         'نومبور',
    colName:       'نام-ڤڠکت',
    colArabicName: 'نام عربي',
    colGender:     'جنتينا',
    colRegularClass: 'کلس عام',
    colDorm:       'اسراما',
    viewInfo:      'ليهت معلومت',
    dormTip:       'ليهت سنارائي مريد سأسراما',
    dormTitle:     (name) => `مريد دالم اسراما ${name}`,
    dormVillage:   (v) => `كامڤوڠ ${v}`,
    dormEmpty:     'تيادا مريد دالم اسراما اين',
    dormLoading:   'سدڠ ممواة...',
    dormColNo:     'نومبور',
    dormColClass:  'کلس عام',
    dormColIslamic: 'کلس اڬام',
  },

  manageRoom: {
    pageTitle:        'ڬلوله بيليک دارجه باهاڬيان اڬام',
    breadHome:        'لامن اوتام',
    breadCurrent:     'بيليک دارجه باهاڬيان اڬام',
    addBtn:           'تمباه بيليک',
    filterAllGender:  '-- سموا جنتينا --',
    filterAllClass:   '-- سموا كلس --',
    listTitle:        'سناراي بيليک دارجه',
    noRooms:          'تيادا داتا بيليک دارجه',
    colClass:         'دارجه',
    colRoom:          'بيليک',
    colGender:        'جنتين',
    colProgram:       'ڤروڬرام',
    colAdvisor:       'ڬورو ناصيحت',
    colStudents:      'مريد',
    modalAddTitle:    'تمباه بيليک دارجه',
    modalEditTitle:   'سوڠيت بيليک دارجه',
    labelClass:       'دارجه',
    classPlaceholder: '-- ڤيليه دارجه --',
    labelRoom:        'بيليک (نومبور بيليک)',
    roomPlaceholder:  'چونتوه 1، 2، A',
    labelGender:      'جنتين مريد',
    labelProgram:     'ڤروڬرام',
    labelAdvisor:     'ڬورو ناصيحت',
    noneOption:       '-- تيادا --',
    incompleteTitle:  'داتا تيداق لڠکاڤ',
    incompleteMsg:    'سيلا اسي نام بيليک، جنتين دان دارجه',
    successTitle:     'برجاي',
    errorTitle:       'رالت',
    successUpdate:    'بيليک دارجه دسوڠيت',
    successAdd:       'بيليک دارجه دتمباه',
    successDelete:    'بيليک دارجه دڤادم',
    confirmDelete:    (r) => `ڤادم بيليک ${r}؟`,
    confirmBtn:       'ڤادم',
    cancelBtn:        'باتل',
    genderLabel:      { m: 'للاکي', f: 'ڤرمڤوان' },
  },

  manageCurriculum: {
    pageTitle:           'ڬلوله سيلابوس باهاڬيان اڬام',
    breadHome:           'لامن اوتام',
    breadCurrent:        'سيلابوس باهاڬيان اڬام',
    syllabusTitle:       'سموا سيلابوس',
    assignedTitle:       'ڤڠاڬيهن سيلابوس',
    addBtn:              'تمباه',
    assignBtn:           'اڬيه',
    colSylYear:          'تاهون سيلابوس',
    noData:              'تيادا داتا',
    colSyllabus:         'سيلابوس',
    colClass:            'دارجه',
    colProgram:          'ڤروڬرام',
    colSubjects:         (n) => `${n} ماتا ڤلاجرن`,
    modalAddSylTitle:    'تمباه سيلابوس',
    labelSylYear:        'تاهون سيلابوس (چونتوه 2567)',
    modalAssignTitle:    'اڬيه سيلابوس',
    labelSyllabus:       'سيلابوس',
    sylPlaceholder:      '-- ڤيليه سيلابوس --',
    labelClass:          'دارجه',
    classPlaceholder:    '-- ڤيليه دارجه --',
    labelProgram:        'ڤروڬرام',
    noneOption:          '-- تيادا --',
    successTitle:        'برجاي',
    errorTitle:          'رالت',
    incompleteTitle:     'داتا تيداق لڠکاڤ',
    confirmBtn:          'ڤادم',
    cancelBtn:           'باتل',
    addedSyl:            'سيلابوس دتمباه',
    deletedSyl:          'سيلابوس دڤادم',
    confirmDeleteSyl:    (y) => `ڤادم سيلابوس تاهون ${y}؟`,
    assignedSuccess:     'سيلابوس دياڬيه',
    cancelledAssign:     'ڤڠاڬيهن دباتلکن',
    confirmCancelAssign: 'باتلکن ڤڠاڬيهن سيلابوس؟',
    incompleteAssignMsg: 'سيلا ڤيليه سيلابوس دان دارجه',
  },

  manageSubject: {
    pageTitle:        'ڬلوله ماتا ڤلاجرن باهاڬيان اڬام',
    breadHome:        'لامن اوتام',
    breadSyllabus:    'سيلابوس',
    breadCurrent:     'ماتا ڤلاجرن',
    addBtn:           'تمباه ماتا ڤلاجرن',
    listTitle:        (n) => `ماتا ڤلاجرن (${n})`,
    noSubjects:       'بلوم اد ماتا ڤلاجرن',
    colCode:          'کود ماتا ڤلاجرن',
    colName:          'نام ماتا ڤلاجرن',
    modalAddTitle:    'تمباه ماتا ڤلاجرن',
    modalEditTitle:   'سوڠيت ماتا ڤلاجرن',
    labelCode:        'کود ماتا ڤلاجرن سمستر ١',
    labelCode2:       'کود ماتا ڤلاجرن سمستر ٢',
    codePlaceholder:  'چونتوه IS101',
    code2Placeholder: 'چونتوه IS102',
    code2Hint:        'بوليه دبيارکن کوسوڠ جک هاڽ دأجر ڤد سمستر ١',
    labelName:        'نام ماتا ڤلاجرن',
    namePlaceholder:  'نام ماتا ڤلاجرن',
    incompleteTitle:  'داتا تيداق لڠکاڤ',
    incompleteMsg:    'سيلا اسي کود سمستر ١ دان نام ماتا ڤلاجرن',
    successTitle:     'برجاي',
    errorTitle:       'رالت',
    successUpdate:    'ماتا ڤلاجرن دسوڠيت',
    successAdd:       'ماتا ڤلاجرن دتمباه',
    successDelete:    'ماتا ڤلاجرن دڤادم',
    confirmDelete:    (c) => `ڤادم ماتا ڤلاجرن ${c}؟`,
    confirmBtn:       'ڤادم',
    cancelBtn:        'باتل',
  },

  manageStudents: {
    pageTitle:          (r) => `مريد دلم بيليک ${r}`,
    breadHome:          'لامن اوتام',
    breadRooms:         'بيليک دارجه',
    breadCurrent:       'مريد',
    filterAllClass:     '-- كلس --',
    filterAllGender:    '-- جنتينا --',
    filterAllRoom:      '-- بيليک --',
    selectRoom:         'سيلا ڤيليه بيليک دارجه دري سنارائي دياتس',
    addStudentTitle:    'تمباه مريد',
    labelStudentId:     'نومبور مريد',
    searchPlaceholder:  'اسي نومبور مريد',
    notFound:           (id) => `مريد نومبور ${id} تيداق جومڤا`,
    enrollBtn:          'دفتر مسوق بيليک اين',
    searchHint:         'چاري دڠن نومبور مريد کمودين تيکن دفتر',
    listTitle:          (n) => `سناراي مريد (${n} ئورڠ)`,
    noStudents:         'بلوم اد مريد دلم بيليک اين',
    colNo:              'نومبور',
    colName:            'نام-ڤڠکت',
    colArabicName:      'نام عرب',
    colGender:          'جنتين',
    colStatus:          'ستاتوس',
    statusBadge:        { 0: 'کلوار', 1: 'سدڠ بلاجر', 3: 'مريد بارو' },
    noInfo:             'تيادا ماکلومت',
    genderLabel:        (g) => g === 'm' ? 'لاکي-لاکي' : 'ڤرمڤوان',
    labelGender:        'جنتين',
    labelStatus:        'ستاتوس',
    confirmUnenroll:    (name) => `تاريق ${name} دري بيليک؟`,
    successTitle:       'برجاي',
    errorTitle:         'رالت',
    enrolledSuccess:    'مريد ديدفترکن',
    unenrolledSuccess:  'مريد دتاريق',
    confirmUnenrollBtn: 'تاريق',
    cancelBtn:          'باتل',
    editBtn:            'سونتيڠ',
    changeStatusTitle:  'سونتيڠ ستاتوس',
  },

  updateStudent: {
    breadHome:        'لامن اوتام',
    breadRooms:       'بيليک دارجه',
    breadStudents:    'مريد',
    breadCurrent:     'سونتيڠ ماکلومت مريد',
    pageTitle:        'سونتيڠ ماکلومت مريد',
    cardTitle:        'ماکلومت ڤريبادي مريد',

    photoNone:        'تيادا ڬمبر',
    choosePhoto:      'ڤيليه ڬمبر',
    uploadPhoto:      'موات نائيق ڬمبر',
    preparingPhoto:   'سدڠ منيدياکن ڬمبر',

    secPersonal:      'ماکلومت ڤريبادي',
    secSibling:       'ماکلومت اديق-براديق',
    secAddressOld:    'الامت اصل',
    secAddressCurrent:'الامت سکارڠ',
    secFather:        'ماکلومت بايه',
    secMother:        'ماکلومت إيبو',
    secGuardian:      'ستاتوس دان والي',
    secOther:         'ماکلومت لائين',

    fIdnumber:        'نومبور ڤڠنالن',
    fName:            'نام-ڤڠکت',
    fArabicName:      'نام عرب',
    fGender:          'جنتينا',
    male:             'لاکي-لاکي',
    female:           'ڤرمڤوان',
    fBlood:           'کومڤولن داره',
    fIdcard:          'نومبور کاد ڤڠنالن',
    fBirthdate:       'تاريخ لاهير',
    birthdateHint:    'چونتوه 22/07/2550',
    fNationality:     'کوارڬانڬاراان',
    fRace:            'باڠسا',
    fReligion:        'اڬام',

    fChildNumber:     'انق کي',
    fSiblingTotal:    'بيلڠن اديق-براديق سکندوڠ',
    unitPerson:       'ئورڠ',
    fSiblingMale:     'لاکي-لاکي',
    fSiblingFemale:   'ڤرمڤوان',

    fHomeId:          'نومبور ڤڠنالن رومه',
    fAddress:         'الامت',
    fSubDistrict:     'موکيم',
    fDistrict:        'دائيره',
    fProvince:        'ولايه',
    fZipcode:         'ڤوس کود',

    fName2:           'نام',
    fJob:             'ڤکرجاان',
    fIncomeYear:      'ڤنداڤتن/تاهون',
    fPhone:           'نومبور تليفون',

    fAverageIncome:   'ڤورت ڤنداڤتن کلوارڬ/تاهون',
    fParentStatus:    'ستاتوس ايبو باڤ',
    stTogether:       'تيڠڬل برسام',
    stSeparated:      'تيڠڬل براسيڠن',
    stDivorced:       'برچرايي',
    fGuardianType:    'والي',
    guardianDad:      'بايه',
    guardianMom:      'إيبو',
    guardianOther:    'لائين-لائين',
    fRelation:        'هوبوڠن',
    fExpensePayer:    'ڤمباي ڤربلنجاان',

    fFavoriteSport:   'سوکن يڠ ديمينتي',
    fFavoriteSubject: 'ماتا ڤلاجرن کڬمرن',
    fFutureStudy:     'هالا توجو ڤلاجرن',
    fFutureJob:       'ڤکرجاان ماس هادڤن',

    saveBtn:          'سيمڤن ماکلومت',
    saveSuccessTitle: 'برجاي',
    saveSuccessText:  'ماکلومت مريد برجاي دسيمڤن',
    loadErrorTitle:   'رالت',
    loadErrorText:    'تيداق داڤت ممڤرأوليه ماکلومت مريد، سيلا چوبا لاڬي',
    saveErrorTitle:   'رالت',
    saveErrorText:    'تيداق داڤت مڽيمڤن ماکلومت، سيلا چوبا لاڬي',

    invalidFileTitle: 'فايل تيداق صح',
    imageOnlyText:    'سيلا ڤيليه ڬمبر سهاج',
    photoLargeTitle:  'ڬمبر ماسيه ترلالو بسر',
    photoLargeText:   'سيلا ڤيليه ڬمبر لبيه کچيل اتاو کورڠکن سايز سبلوم موات نائيق',
    uploadOkTitle:    'ڬمبر برجاي دموات نائيق',
    uploadFailTitle:  'ڬاڬل موات نائيق ڬمبر',
    uploadFailText:   'سيلا چوبا لاڬي',
  },

  // ڤريڠکت دارجه باهاڬين اڬام — کونچي سام دڠن server/utils/islamicLevels.js
  islamicLevel: {
    ibtidai:    'ابتدائي',
    mutawassit: 'متوسط',
    sanawi:     'ثانوي',
    aip:        'بيليک خاص AIP',
    stp:        'بيليک خاص STP',
  },

  risk: {
    red:              'ريسيکو تيڠڬي',
    orange:           'بريسيکو',
    yellow:           'دالم ڤمرهاتين',
    green:            'بياسا',
    axisAttendance:   'ڤرهاديران',
    axisBehavior:     'کلاکوان',
    axisConcern:      'لاڤورن ڤنجاڬان',
    roleAcademicHead: 'کتوا اکاديميک اڬام',
    roleLevelHead:    'کتوا ڤريڠکت',
    roleAdvisor:      'ݢورو کلس اڬام',
    roleFallback:     'ڤنتاوان مريد',
    whoAdvisor:       'ݢورو کلس اڬام',
    whoHead:          'کتوا ڤريڠکت',
  },

  tracking: {
    pageTitle:       'سيستم ڤنتاوان مريد (باهاڬين اڬام)',
    pageSubtitle:    'مڠومڤولکن تندا ڤريڠاتن سچارا لڠسوڠ — ڬاڬل حاضر · کلاکوان · لاڤورن ڤنجاڬان · کصيحتن',
    breadcrumb:      'ڤنتاوان مريد باهاڬين اڬام',
    cardHighRisk:    'ريسيکو تيڠڬي',
    cardRisk:        'بريسيکو',
    cardWatch:       'دالم ڤمرهاتين',
    cardLowBehavior: 'کلاکوان دباوه ڤياوي',
    cardConcern:     'اد لاڤورن ڤنجاڬان',
    breakdownTitle:  'مڠيکوت سبب',
    breakdownHelp:   'سموا ڤرکارا يڠ سام ڤريڠکتڽ دڠن ڤريڠکت کسلوروهن مريد اکن دکيرا، جادي سئورڠ مريد بوليه دکيرا لبيه دري ساتو ڤرکارا — جوملهڽ بوليه لبيه بسر دري اڠک دالم کاد',
    breakdownEmpty:  'تيادا مريد دالم ڤريڠکت اين',
    noAttendanceWarn:(n) => `ڤريکسا ناما باهاڬين اڬام بلوم چوکوڤ اونتوق ${n} اورڠ مريد — ڤرکارا ڤرهاديران مريک ماسيه دتونجوق سباڬاي بياسا`,
    filterGender:    'جنتينا',
    filterClass:     'دارجه',
    filterRoom:      'بيليک دارجه',
    filterAll:       'سموا',
    filterRisk:      'ڤريڠکت ريسيکو',
    riskAll:         'سموا',
    listTitle:       'سوسونن مريد مڠيکوت ريسيکو کسلوروهن',
    found:           (n) => `دجومڤاي ${n} اورڠ`,
    empty:           'تيادا مريد يڠ مننوهي ڤناڤيس اين',
    printBtn:        'چيتق',
    printBlocked:    'تيدق بوليه دچيتق',
    printBlockedText:'سيلا بنرکن popup ڤادا ڤلايار',
    viewTable:       'ڤاڤرن جادول',
    viewCard:        'ڤاڤرن کاد',
    colNo:           '#',
    colStudent:      'مريد',
    colRoom:         'بيليک اڬام',
    colRegularRoom:  'بيليک عام',
    colDorm:         'اسراما',
    colOverall:      'ريسيکو',
    colAttendance:   'ڤرهاديران',
    colBehavior:     'کلاکوان',
    colConcern:      'لاڤورن ڤنجاڬان',
    colHealth:       'کصيحتن',
    tipOverall:      'ڤريڠکت کسلوروهن = ڤرکارا يڠ ڤاليڠ بوروق دري ٣ ڤرکارا (ڤرهاديران/کلاکوان/لاڤورن ڤنجاڬان)',
    tipAttendance:   'ڬاڬل حاضر/لمبت/چوتي دان % ڬاڬل حاضر — ريسيکو تيڠڬي لبيه ٤٠%، بريسيکو ٢٠–٤٠%، دالم ڤمرهاتين ١٠–٢٠% (مولا دکيرا سلڤس ٥ حصة)',
    tipBehavior:     'مرک کلاکوان يڠ تيڠڬل دري ١٠٠ (دتولق اوليه باهاݢين تاتاترتيب، دتمبه بالق دڠن کرجا سوکارلا يڠ سله سياڤ)',
    tipConcern:      'ڤرکارا يڠ دلاڤورکن ݢورو دان بلوم سلساي — دايکت ڤادا مريد، تيدق دڤيسهکن مڠيکوت باهاڬين',
    tipHealth:       'اد ماکلومت کصيحتن/ڤڽاکيت اتاو BMI لوار ڤياوي',
    absentShort:     (n, pct) => `ڬاڬل حاضر ${n} · ${pct}%`,
    lateLeave:       (late, leave) => `لمبت ${late} · چوتي ${leave}`,
    pointsLeft:      (n) => `${n} مرک`,
    concernCount:    (n) => `${n} ڤرکارا`,
    detailBtn:       'ليهت ڤرينچين',
    clickRowHint:    'کليک بارس اونتوق ليهت ڤرينچين مريد',
    bmiOut:          (v) => `BMI ${v} لوار ڤياوي`,
    hasHealthInfo:   'اد ماکلومت کصيحتن/ڤڽاکيت',
    printTitle:      'سوسونن مريد مڠيکوت ريسيکو کسلوروهن (باهاڬين اڬام)',
    printConditions: 'شرط',
    printGenderAll:  'سموا جنتينا',
    printClassAll:   'سموا دارجه',
    printRoomAll:    'سموا بيليک',
    printSummary:    (total, red, orange, yellow, green) => `جومله ${total} اورڠ (ريسيکو تيڠڬي ${red} / بريسيکو ${orange} / دالم ڤمرهاتين ${yellow} / بياسا ${green})`,
    printAt:         'دچيتق ڤادا',
  },

  trackingDetail: {
    breadcrumb:      'ڤنتاوان مريد باهاڬين اڬام',
    pageTitle:       'ڤرينچين ڤنتاوان مريد',
    back:            'کمبالي',
    notFound:        'تيادا ماکلومت مريد',
    noAccess:        'تيادا کبنرن ملیهت ماکلومت مريد اين',
    infoRoom:        'بيليک اڬام',
    infoRegular:     'بيليک عام',
    infoProgram:     'ڤروڬرام',
    sumAttendance:   'ڤرهاديران باهاڬين اڬام',
    sumPresent:      'حاضر',
    sumAbsent:       'ڬاڬل حاضر',
    sumLate:         'لمبت',
    sumLeave:        'چوتي',
    sumTotal:        'جومله',
    sumRate:         'ڬاڬل حاضر (%)',
    bySubject:       'ڤرهاديران مڠيکوت ماتا ڤلاجرن',
    noSubjectAtt:    'بلوم اد داتا ڤريکسا ناما باهاڬين اڬام',
    colSubject:      'ماتا ڤلاجرن',
    colTeacher:      'ݢورو',
    attDetail:       'سنارائي ڤريکسا ناما (تربارو دهولو)',
    noAttDetail:     'بلوم اد سنارائي ڤريکسا ناما',
    colDate:         'تاريخ',
    colPeriod:       'حصة',
    colStatus:       'ستاتوس',
    colTopic:        'توڤيک ڤلاجارن',
    statusPresent:   'حاضر',
    statusAbsent:    'ڬاڬل حاضر',
    statusLate:      'لمبت',
    statusLeave:     'چوتي',
    attDetailMore:   (shown, total) => `منونجوقکن ${shown} سنارائي تربارو دري جومله ${total}`,
    scores:          'مرک ماتا ڤلاجرن اڬام',
    scoresNote:      'ماکلومت تمبهن سهاج، تيدق دکيرا دالم ڤريڠکت ريسيکو — مرک داسي سکالي ڤادا اخير سمستر (ڤنوه ٥٠ ستياڤ سمستر) جادي تربالو لمبت اونتوق منجادي تندا ڤريڠاتن',
    noScores:        'بلوم اد مرک',
    colTerm1:        'سمستر ١',
    colTerm2:        'سمستر ٢',
    colScoreAvg:     'ڤوراتا',
    conduct:         'کلاکوان',
    conductRemaining:'مرک يڠ تيڠڬل',
    conductDeducted: 'دتولق',
    conductMerit:    'دتمبه بالق (سوکارلا)',
    noConduct:       'بلوم اد ڤنولقن مرک',
    colRule:         'ڤرکارا',
    colPoints:       'مرک',
    colBy:           'ڤنچاتت',
    merits:          'کرجا سوکارلا',
    noMerits:        'بلوم اد کرجا سوکارلا',
    colActivity:     'اکتيۏيتي',
    meritAssigned:   'تله دبري',
    meritCompleted:  'سله سياڤ',
    meritCancelled:  'دباتلکن',
    concerns:        'ڤرکارا يڠ دلاڤورکن',
    concernsNote:    'دايکت ڤادا مريد، تيدق دڤيسهکن مڠيکوت باهاڬين، جادي ترماسوق ڤرکارا يڠ دلاڤورکن ݢورو باهاڬين عام',
    noConcerns:      'تيادا ڤرکارا يڠ دلاڤورکن',
    colCategory:     'بيدڠ',
    colDetail:       'ڤرينچين',
    concernOpen:     'ماسيه تربوک',
    concernProgress: 'سدڠ دجاڬ',
    concernResolved: 'سوده سلساي',
    // بيدڠ ڤرکارا — کونچي سام دڠن tb_student_concern.concern_category
    catLearning:     'بيدڠ ڤلاجارن',
    catHealth:       'بيدڠ کصيحتن',
    catFamily:       'بيدڠ کلوارڬ',
    catEmotional:    'بيدڠ ايموسي/جيوا',
    catPeer:         'بيدڠ راکن/سوسيال',
    catOther:        'لائين٢',
    health:          'برت/تيڠڬي',
    noHealth:        'بلوم اد داتا برت/تيڠڬي',
    colMonth:        'بولن',
    colHeight:       'تيڠڬي (سم)',
    colWeight:       'برت (کڬ)',
    colBmi:          'BMI',
    healthNotes:     'ماکلومت کصيحتن',
    healthDrug:      'الرڬي اوبت',
    healthFood:      'الرڬي ماکنن',
    healthSyndrome:  'ڤڽاکيت',
    healthEver:      'ڤرنه مڠيدڤ',
    healthFacing:    'سدڠ دراوت',
    healthAccident:  'سجاره کمالڠن',
  },

  careTracking: {
    pageTitle:       'ڤنتاوان ڤنجاڬان مريد (باهاڬين اڬام)',
    pageTitleRead:   'ستاتوس ڤنتاوان ڤنجاڬان مريد (باهاڬين اڬام)',
    breadcrumb:      'ڤنتاوان مريد باهاڬين اڬام',
    subtitle:        'تندا اڤابيلا لڠکه سوده دلقساناکن — لڠکه ݢورو کلس هاڽ بوليه دتندا اوليه ݢورو کلس اڬام بيليک ايت، لڠکه کتوا ڤريڠکت هاڽ اوليه کتوا ڤريڠکت برکناان',
    subtitleRead:    'ملیهت ستاتوس ڤلقسانأن ݢورو کلس اڬام دان کتوا ڤريڠکت (ليهت سهاج) — توجوکن ڤادا کوتق يڠ دتندا اونتوق تاهو سياڤ دان بيلا',
    stepsTitle:      'لڠکه ڤنجاڬان',
    criteria:        'کريتيريا',
    criteriaAttendance:'دالم ڤمرهاتين ڬاڬل حاضر ١٠–٢٠% · بريسيکو ٢٠–٤٠% · ريسيکو تيڠڬي لبيه ٤٠%',
    criteriaBehavior:'دالم ڤمرهاتين مرک کلاکوان کورڠ ٩٠ · ريسيکو تيڠڬي کورڠ ٧٠',
    cumulativeNote:  'مريد ڤريڠکت تيڠڬي ڤرلو ملالوي لڠکه ڤريڠکت رنده جوڬ — چونتوهڽ ريسيکو تيڠڬي ڤرلو لڠکڤ سموا کوتق بارو دکيرا "لڠکڤ"',
    progressNote:    'دباوه کوتق يڠ دتندا اکن دتونجوق اڠک ماس دتندا → سکارڠ اونتوق ملیهت کماجوان سلڤس تيندقن:',
    trendBetter:     'برتمبه بايق',
    trendWorse:      'برتمبه بوروق',
    trendSame:       'ککل سام',
    progressLegacy:  '(کوتق يڠ دتندا سبلوم سيستم اين اد تيادا اڠک ڤربنديڠن)',
    lockedTip:       'تيدق بوليه ممباتلکن تندا — اڠک تله برواب درڤد ماس دتندا، جک دتندا سمولا سيستم اکن مڽيمڤن اڠک هاري اين (جک ترسالح تندا سيلا مکلومکن کڤد ڤنتدبير سيستم)',
    lockedNote:      'کوتق يڠ اڠکڽ تله برواب درڤد ماس دتندا اکن دکونچي درڤد دباتلکن — کران جک دباتل لالو دتندا سمولا، سيستم اکن مڽيمڤن اڠک هاري دتندا سمولا دان اڠک اول اونتوق مڠوکور کماجوان اکن هيلڠ',
    cardPending:     'بلوم لڠکڤ',
    cardComplete:    'سوده لڠکڤ',
    filterLevel:     'ڤريڠکت',
    filterLevelAll:  'سموا ڤريڠکت',
    filterStatus:    'ستاتوس',
    statusPending:   'بلوم لڠکڤ',
    statusComplete:  'سوده لڠکڤ',
    statusAll:       'سموا',
    listTitle:       'سنارائي مريد',
    count:           (n) => `${n} اورڠ`,
    empty:           'تيادا مريد يڠ مننوهي ڤناڤيس اين',
    clickNameHint:   'کليک ناما اونتوق ليهت ڤرينچين مريد',
    colNo:           '#',
    colStudent:      'مريد',
    colRoom:         'بيليک اڬام',
    colLevelInfo:    'ڤريڠکت / ماکلومت',
    colContact:      'نومبور ڤنجاݢ',
    colStatus:       'ستاتوس',
    colContract:     'ڤرجنجين',
    stepHeadYellow:  'برچاکڤ/مننڬور',
    stepHeadOrange:  'تلفون ڤنجاݢ/بوات ڤرجنجين',
    complete:        'لڠکڤ',
    missing:         (n, total) => `کورڠ ${n}/${total}`,
    notYet:          'بلوم سمڤاي',
    notYetTip:       (level) => `بلوم سمڤاي ڤريڠکت ${level} — بلوم ڤرلو لڠکه اين`,
    notAllowedTip:   (who) => `بلوم دلقساناکن — هاڽ ${who} بوليه مننداڽ`,
    pendingTip:      (label) => `بلوم دلقساناکن: ${label}`,
    noRecorder:      'ڤنچاتت تيدق دڽاتاکن',
    tickedAt:        'ماس دتندا',
    nowAt:           'سکارڠ',
    addNote:         'تمبه چاتتن (تيدق واجب)',
    noteTitle:       (name) => `${name} · چاتتن ريڠکس (تيدق واجب)`,
    noteSave:        'سيمڤن',
    noteCancel:      'باتل',
    noPhone:         'تيادا نومبور',
    attendanceInfo:  (a) => `ڬاڬل حاضر ${a.absent} کالي (${a.absenceRate}%) · لمبت ${a.late} · چوتي ${a.leave}`,
    behaviorInfo:    (a) => `تيڠڬل ${a.remaining} مرک (دتولق ${a.deducted}${a.merited ? ` · دتمبه بالق ${a.merited}` : ''})`,
    // สามคีย์นี้เป็นข้อความบนเอกสารที่สั่งพิมพ์ ซึ่งเป็นภาษาไทยเสมอไม่ตามภาษาเมนู
    // (โค้ดอ่านจาก th เท่านั้น) จึงคงข้อความไทยไว้ ไม่ใช่ลืมแปล
    printTitle:      'ติดตามการดูแลนักเรียน (ภาคศาสนา)',
    printSummary:    (total, complete, pending) => `รวม ${total} คน (ครบ ${complete} / ยังไม่ครบ ${pending})`,
    printLegend:     '✔ ดำเนินการแล้ว · ☐ ยังไม่ดำเนินการ · - ยังไม่ถึงระดับของขั้นนี้',
    contractBtn:     'چيتق سورت ڤرجنجين (A4)',
    contractBtnShort:'چيتق ڤرجنجين',
    contractTitle:   'سورت ڤرجنجين',
    contractHint:    'روانڬ يڠ تيادا داتا اکن دچيتق سباڬاي ڬاريس ڤوتوس اونتوق دتوليس تاڠن',
    contractPrint:   'چيتق A4',
    contractClose:   'توتوڤ',
    contractError:   'ڬاڬل ممبوک سورت ڤرجنجين',
    saveError:       'ڬاڬل مڽيمڤن',
    loadError:       'ڬاڬل ممواتکن داتا',
    busyTitle:       'سيستم سدڠ سيبوق',
    busyText:        'رامي ڤڠڬونا مڠڬوناکن هلامن اين ڤادا ماس اين، سيلا توڠڬو سبنتر دان چوبا لاڬي',
    busyRetry:       'چوبا لاڬي',
    busyLater:       'نانتي دهولو',
    busyUnderstood:  'فهم',
    retryText:       'سيلا چوبا لاڬي',
  },

  // ---- هومود اکاديميک باهاڬين اڬام (pos 57) ----
  academic: {
    groupTitle:   'اکاديميک اڬام',
    filterYear:   'تاهون ڤڠاجين',
    filterClass:  'دارجه',
    filterRoom:   'بيليک',
    filterGender: 'جنتينا',
    allClasses:   'سموا دارجه',
    allRooms:     'سموا بيليک',
    allGenders:   'سموا جنتينا',

    // ڤنتاوان توڬس ݢورو کلس اڬام — ดู th.js สำหรับที่มาของสามงานนี้
    advisorTasks: {
      pageTitle:          'ڤنتاوان توڬس ݢورو کلس اڬام',
      subtitle:           'بيليک مان يڠ بلوم سياڤ — کليک بارس اونتوق ليهت سنارائي (ليهت سهاج)',
      onlyPending:        'هاڽ بيليک يڠ اد توڬس ترتوڠڬق',

      statDormMissing:    'مريد يڠ بلوم اد ڤندفترن اسراما',
      statDormMissingSub: (n) => `ترتوڠڬق دالم ${n} بيليک`,
      statCarePending:    'مريد يڠ لڠکه ڤنجاڬان بلوم لڠکڤ',
      statCarePendingSub: (n) => `دالم ${n} بيليک`,
      statLeaves:         'سورت چوتي تاهون اين',
      statLeavesSub:      'هاڽ يڠ دمکلومکن اوليه ݢورو کلس اڬام',
      statStale:          (d) => `ݢورو يڠ تيدق ماسوق سيستم لبيه ${d} هاري`,
      statStaleSub:       (never, total) => `تيدق ڤرنه ماسوق ${never} اورڠ · جملاه ݢورو کلس ${total} اورڠ`,

      listTitle:          'مڠيکوت بيليک',
      roomCount:          (n) => `${n} بيليک`,
      dormHint:           'سکوله اين اسراما سڤنوهڽ — سموا مريد ڤرلو اد ڤندفترن اسراما؛ يڠ تيادا برمعنى بلوم دداڤترکن، بوکن مريد بالق هاري',
      empty:              'تيادا بيليک يڠ مننوهي ڤناڤيس اين',
      allDone:            'سموا بيليک دالم ڤناڤيس اين تيادا توڬس ترتوڠڬق',
      footerHint:         'ليهت سهاج — اتور اسراما، مکلومکن چوتي دان تندا لڠکه ڤنجاڬان دبوات د مينو ݢورو کلس اڬام',

      colRoom:            'دارجه/بيليک',
      colAdvisor:         'ݢورو کلس / ماسوق سيستم تراخير',
      colStudents:        'مريد',
      colDorm:            'ڤندفترن اسراما',
      colCare:            'لڠکه ڤنجاڬان مريد',
      colLeave:           'چوتي',

      noAdvisor:          'بلوم دتتڤکن ݢورو کلس',
      inactiveAccount:    'اکاون دتوتوڤ',
      neverLogin:         'تيدق ڤرنه ماسوق سيستم',
      loginToday:         'ماسوق هاري اين',
      loginDays:          (n) => `${n} هاري لالو`,

      dormComplete:       'لڠکڤ',
      dormMissing:        (n) => `کورڠ ${n}`,
      careNone:           'تيادا مريد يڠ مننوهي کريتيريا',
      careComplete:       (n) => `لڠکڤ ${n} اورڠ`,
      carePending:        (pending, total) => `ترتوڠڬق ${pending}/${total} اورڠ`,

      tab_dorm:           'ڤندفترن اسراما',
      tab_care:           'لڠکه ڤنجاڬان',
      tab_leave:          'سورت چوتي',
      loading:            'سدڠ مموات...',
      detailEmpty:        'تيادا داتا دالم تاجوق اين',

      colStudent:         'مريد',
      colDormName:        'اسراما',
      colCheckin:         'تاريخ ماسوق اسراما',
      noDorm:             'بلوم اد اسراما',

      colRisk:            'ڤريڠکت',
      colWhy:             'سبب مننوهي کريتيريا',
      colSteps:           'لڠکه ݢورو کلس',
      stepDoneBy:         (name, when) => `تله دبوات اوليه ${name}${when ? ` ڤادا ${when}` : ''}`,
      absentOf:           (absent, total, rate) => `تيدق هادير ${absent}/${total} ماس (${rate}%)`,
      conductLeft:        (n) => `مرک برباکي ${n}`,

      colLeaveType:       'جنيس',
      colLeaveDates:      'تاريخ چوتي',
      colNote:            'چاتتن',
      colReportedBy:      'ڤمکلوم',
    },

    attendance: {
      pageTitle:       'لاڤورن ڤرهاديران (باهاڬين اڬام)',
      mode_day:        'هارين',
      mode_week:       '7 هاري',
      mode_month:      'بولنن',
      prev:            'سبلومڽ',
      next:            'برايکوتڽ',
      today:           'هاري اين',

      present:         'هادير',
      absent:          'تيدق هادير',
      late:            'لمبت',
      leave:           'چوتي',

      coverage:        'سوده دأمبيل',
      slots:           'ماس',
      ofAll:           (pct) => `${pct}% درڤد يڠ دأمبيل`,

      uncheckedTitle:  'ماس يڠ بلوم دأمبيل کهاديرن',
      slotCount:       (n) => `${n} ماس`,
      allChecked:      'کهاديرن تلاه دأمبيل لڠکڤ دالم تيمڤوه اين',
      excusedNote:     (n) => `(تيدق ترماسوق ${n} ماس يڠ تقويم تنداکن تياد ڤڠاجارن)`,
      noTeacher:       'بلوم اد ݢورو',

      byDateTitle:     'نسبه مڠيکوت هاري',
      byRoomTitle:     'مڠيکوت بيليک',
      roomCount:       (n) => `${n} بيليک`,
      showAllRooms:    (n) => `ڤاڤر جوݢ بيليک يڠ نورمل (${n} بيليک)`,
      noRoomIssue:     'سموا بيليک لڠکڤ دان تياد مريد تيدق هادير دالم تيمڤوه اين',
      noRecord:        'بلوم اد ڤڠمبيلن کهاديرن',

      colDate:         'تاريخ',
      colPeriod:       'ماس',
      colRoom:         'بيليک',
      colSubject:      'ماتا ڤلاجرن',
      colTeacher:      'ݢورو',
      colShare:        'نسبه',
      colChecked:      'سوده دأمبيل',
      colAbsentRate:   '% تيدق هادير',
      colStudent:      'مريد',
      colOfChecked:    '% تيدق هادير',

      absentStudentsTitle: 'مريد يڠ تيدق هادير دالم تيمڤوه اين',
      noAbsentStudent: 'تياد مريد تيدق هادير دالم تيمڤوه اين',
      cappedNote:      '(ڤاليڠ باڽق 100 اورڠ ڤرتام، ايکوت بيلڠن تيدق هادير)',
      clickStudentHint:'تکن بارس اونتوق ممبوک هلامن ڤنتاوان مريد',

      noTeachingTitle: 'تاريخ يڠ تقويم تنداکن تياد ڤڠاجارن',
      noTeachingNote:  'هاڽ رکود چوتي سلوروه سکوله — رکود يڠ مڽاتاکن بيليک/دارجه ترتنتو اداله بيليک باهاڬين عام، تيدق بوليه دڤادنکن دڠن بيليک اڬام',
    },

    absence: {
      pageTitle:        'ڤنتاوان مريد تيدق هادير (باهاڬين اڬام)',
      filterStatus:     'ستاتوس يڠ دڤاڤر',
      statPeriodsOf:    (s) => `ماس ${s}`,
      statStudentsOf:   (s) => `مريد ${s}`,
      statWithLeave:    'تيدق هادير/لمبت والاوڤون اد سورت چوتي',
      withLeaveHint:    'ݢورو تنداکن تيدق هادير اتاو لمبت والاوڤون مريد تلاه ممفون چوتي — ڤرلو دبتولکن',
      hasLeave:         (type) => `اد سورت چوتي (${type})`,
      matchedLeave:     (type) => `سورت چوتي: ${type}`,
      noLeaveDoc:       'تياد سورت چوتي دالم سيستم',
      onlyWithLeave:    (n) => `هاڽ يڠ اد سورت چوتي (${n})`,
      viewPeriod:       'مڠيکوت ماس',
      viewStudent:      'رومسن مڠيکوت مريد',
      colStatus:        'ستاتوس',
      colRegularClass:  'دارجه عام',
      colDorm:          'اسراما',
      colTotal:         'جومله',
      colDays:          'بيلڠن هاري',
      colWithLeave:     'اد چوتي',
      empty:            'تياد رکود باڬي ستاتوس يڠ دڤيليه دالم تيمڤوه اين',
      footerHint:       'تکن بارس اونتوق ممبوک هلامن ڤنتاوان مريد · وارنا بارس: ميره = تيدق هادير · کونيڠ = لمبت · بيرو = چوتي · تندا کونيڠ دبلاکڠ نام اداله تيدق هادير/لمبت والاوڤون اد سورت چوتي',
    },

    leave: {
      pageTitle:        'مريد يڠ برچوتي (باهاڬين اڬام)',
      type: {
        sick:     'چوتي ساکيت',
        personal: 'چوتي أوروسن',
        home:     'بالق کروماه',
      },
      source: {
        advisor:         'ݢورو کلس (عام)',
        islamic_advisor: 'ݢورو کلس (اڬام)',
        discipline:      'بهاݢين تاتترتيب',
        academic:        'کتوا اکاديميک',
        home_leave:      'سورت بالق کروماه (تاتترتيب)',
      },
      filterType:       'جنيس',
      allTypes:         'سموا جنيس',
      filterSource:     'بهاݢين ڤملاڤور',
      allSources:       'سموا بهاݢين',
      search:           'چاري',
      searchPlaceholder:'ناما، نومبور ڤڠنلن اتاو چاتتن',
      statLeaves:       'سورت چوتي',
      statStudents:     'مريد',
      statDays:         'جمله هاري چوتي',
      daysHint:         'هاڽ هاري دالم تيمڤوه يڠ دڤيليه',
      statByType:       'مڠيکوت جنيس',
      listTitle:        'سنارائي چوتي',
      leaveCount:       (n) => `${n} رکود`,
      colType:          'جنيس',
      colDates:         'تيمڤوه چوتي',
      colDays:          'هاري',
      colNote:          'چاتتن',
      colReportedBy:    'ڤملاڤور',
      openEnded:        'بلوم دتنتوکن تاريخ بالق',
      returnedAt:       (at) => `ماسوق سمولا ${at}`,
      empty:            'تياد چوتي دالم تيمڤوه اين',
      footerHint:       'ترماسوق سموا جنيس چوتي يڠ برکسن کڤد مريد، باءيق يڠ دلاڤور ݢورو ماهوڤون سورت بالق يڠ دلولوسکن · روڠن هاري ممڤاڤرکن "هاري دالم تيمڤوه / جمله هاري سورت"',
    },

    // ---- ڤرهاديران مڠيکوت مريد ----
    individual: {
      pageTitle:      'ڤرهاديران مڠيکوت مريد (باهاڬين اڬام)',
      tabIndividual:  'مڠيکوت مريد',
      tabRisk:        'کومڤولن بريسيکو',
      search:         'چاري مريد',
      searchPlaceholder: 'نومبور ڤڠنلن اتاو ناما',
      searchBtn:      'چاري',
      noResult:       'تيدق جومڤا مريد يڠ دچاري',
      resultCount:    (n) => `جومڤا ${n} اورڠ`,
      resultCapped:   '(ڤاليڠ باڽق 30 اورڠ ڤرتام — چاري دڠن لبيه تڤت جک تيدق جومڤا)',
      pickStudent:    'چاري مريد اتاو تکن درڤد تاب کومڤولن بريسيکو اونتوق مليهت ڤرهاديران مڠيکوت ماس',
      from:           'درڤد تاريخ',
      to:             'هيڠڬ تاريخ',
      wholeYear:      'سلوروه تاهون',
      rangeHint:      'تياد تيمڤوه = سلوروه تاهون ڤڠاجين',
      needBothDates:  'ڤرلو مڽاتاکن تاريخ مولا دان تاريخ اخير',
      regularClass:   'دارجه عام',
      dorm:           'اسراما',
      moved:          'تلاه برڤينده بيليک',
      trackingBtn:    'هلامن ڤنتاوان مريد',
      statRate:       'ڤرهاديران',
      rateHint:       'هادير + لمبت دکيرا هادير',
      hasLeave:       (type) => `اد سورت چوتي (${type})`,
      bySubjectTitle: 'ڤرهاديران مڠيکوت ماتا ڤلاجرن',
      subjectCount:   (n) => `${n} ماتا ڤلاجرن`,
      colSubject:     'ماتا ڤلاجرن',
      colTeacher:     'ݢورو',
      colTotal:       'جمله',
      colRate:        'ڤرهاديران',
      detailTitle:    'سنارائي ڤرهاديران',
      recordCount:    (n) => `${n} کالي`,
      colDate:        'تاريخ',
      colPeriod:      'ماس',
      colTopic:       'تاجوق ڤڠاجارن',
      colStatus:      'ستاتوس',
      noTopic:        'تيدق دڽاتاکن',
      empty:          'تياد ماكلومت ڤرهاديران دالم تيمڤوه يڠ دڤيليه',
      notFound:       'تيدق جومڤا رکود اڬام مريد اين دالم تاهون ڤڠاجين يڠ دڤيليه',
      excel:          'Excel',
      detailFooter:   'بارس کونيڠ اداله تيدق هادير والاوڤون اد سورت چوتي · ڤمبتولن کهاديرن اداله توݢس ݢورو',
      minAbsent:      'تيدق هادير سکورڠڽ (کالي)',
      riskTitle:      'مريد بريسيکو تيدق هادير',
      riskEmpty:      'تياد مريد يڠ منچاڤاي کريتيريا',
      riskCapped:     '(ڤاليڠ باڽق 500 اورڠ ڤرتام)',
      riskFooter:     'تکن بارس اونتوق مليهت ڤرهاديران مڠيکوت ماس دالم تيمڤوه يڠ سام · تيدق ترماسوق مريد يڠ تلاه کلوار',
    },

    studentList: {
      pageTitle:         'سنارائي مريد مڠيکوت بيليک (باهاڬين اڬام)',
      advisor:           'ݢورو کلس',
      colNo:             'بيل',
      colId:             'نومبور ڤڠنلن',
      colName:           'ناما',
      colRegularClass:   'دارجه عام',
      colDorm:           'اسراما',
      colStatus:         'ستاتوس',
      colInfo:           'ماکلومت',
      status: {
        active:    'سدڠ بلاجر',
        withdrawn: 'تلاه کلوار',
        graduated: 'تلاه تامت',
        newcomer:  'مريد بارو',
      },
      viewBtn:           'ليهت',
      viewBtnTip:        'ليهت ماکلومت مريد (باچ سهاج)',
      viewTable:         'ڤاڤرن جدول',
      viewCard:          'ڤاڤرن کاد',
      dormTip:           'ليهت سناراي مريد سأسراما',
      dormTitle:         (name) => `مريد دالم اسراما ${name}`,
      dormVillage:       (v) => `کامڤوڠ ${v}`,
      dormEmpty:         'تيادا مريد دالم اسراما اين',
      dormColClass:      'دارجه عام',
      dormColIslamic:    'دارجه اڬام',
      loading:           'سدڠ ممواتکن...',
      noStudents:        'تيادا مريد دالم بيليک اين',
      newcomerCount:     (n) => `مريد بارو ${n} اورڠ`,
      leftCount:         (n) => `تلاه کلوار ${n} اورڠ`,
      movedCount:        (n) => `برڤينده بيليک ${n} اورڠ`,
      roomHeading:       (room) => `دارجه ${room}`,
      selectRoom:        '-- ڤيليه بيليک --',
      pickRoomFirst:     'ڤيليه بيليک اونتوق مليهت سناراي مريد',
      movedTo:           (room) => `برڤينده که ${room}`,
      movedToUnknown:    'تلاه برڤينده (تيدق جومڤا بيليک بارو)',
      inRoomCount:       (n) => `دالم بيليک ${n} اورڠ`,
    },
  },
}
